/**
 *
 * Javascript behavior for: floating_navigation shortcode
 */
Mmg.addShortcodeFilter(
  "floating_navigation",
  ".sc-floating-navigation",
  (el, model, $, selector, className) => {

    /**
     * Initialize the widget
     */
    (function init() {
      Mmg.event.observeSticky(selector);
    })();

  }
);
